// extracted by mini-css-extract-plugin
module.exports = {"legacyContent":"style_legacyContent__Cs4k9 view_contentLane__Bdya1"};